export default __webpack_public_path__ + "static/bog-53f4b81834b6898de0a1785bc224a89d.png";